import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";
import UserSideBar from "./Components/Sidebar";
import { Calendar } from 'primereact/calendar';
import {
    Search1Icon,
    UserAppointmentImg1,
    UserAppointmentImg4
} from "../../Constant/Index";
const Timings = () => {
    const [date, setDate] = useState(null);
    const Services = [
        {
            Name: "John Merchant",
            Para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            Image: UserAppointmentImg1
        },
        {
            Name: "Couples Psychotherapy",
            para: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            Image: UserAppointmentImg4
        }
    ];
    return (
        <>
            <Header />
            <UniversalBanner heading="My Profile" />
            <section className="profile-main">
                <div className="container">
                    <div className="profile-start">
                        <div className="row">
                            <UserSideBar />
                            <div className="col-lg-9 col-md-8">
                                <div className="profile-box">
                                    <div className="top-heading d-flex gap-md-4 align-items-md-center flex-column flex-md-row pb-4">
                                        <h3 className="md-heading min-width-fit mb-0">My Timings</h3>
                                        <hr className="w-100" />
                                        {/* <Link className="secondary-btn-2 ms-auto" to="/therapist/service/add">Add New Service</Link> */}

                                    </div>
                                    <div className="timing-slots">
                                        <div className="row">
                                            <div className="col-lg-6 order-1 order-lg-0 mt-5 mt-lg-0">
                                                <div className="available-times">
                                                    <div className="top-area">
                                                        <h6 className="xs-heading small mb-0">Enter Available Timing</h6>
                                                        <p className="text">Enter Available timing For 27 April</p>
                                                    </div>
                                                    <div className="form-area">
                                                        <div className="from-groupt with-range mb-3">
                                                            <label htmlFor="from" className="from">From</label>
                                                            <input type="text" name="" placeholder="00:00 AM" className="form-control text-end" id="from" />
                                                        </div>
                                                        <div className="from-groupt with-range mb-3">
                                                            <label htmlFor="from" className="from">To</label>
                                                            <input type="text" name="" placeholder="00:00 PM" className="form-control text-end" id="to" />
                                                        </div>
                                                        <button className="btn btn-secondary  mb-3 d-block w-100">Add Time Slot</button>
                                                    </div>
                                                    <div className="slots-list">
                                                        <div className="single-slot mb-3">
                                                            <div className="date-here single-time">
                                                                <span className="quest">For Date</span>
                                                                <span className="answer">27 April 2023</span>
                                                            </div>
                                                            <div className="time-here single-time">
                                                                <span className="quest">Timing</span>
                                                                <span className="answer">6:00 pm to 7:00 Am</span>
                                                            </div>
                                                            <div className="close-here">
                                                                <button>
                                                                    <i className="fa fa-close"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button className="btn save-btn mb-3 d-block w-100">Save Changes</button>
                                                </div>
                                            </div>
                                            <div className="col-xl-5 col-lg-6  ms-auto">
                                                <div className="select-the-date ">
                                                    <label htmlFor="" className="main-label xs-heading small pb-4">Enter Available Date</label>
                                                    <div className="calendar-wrapper primary-bg pt-2 pb-3 with-radius primary-boxshadow">

                                                        <Calendar value={date} onChange={(e) => setDate(e.value)} inline />
                                                        <div className="buttons-flex d-flex gap-2 px-4 pt-3">
                                                            <div className="col-md-6 px-0">
                                                                <button className=" w-100 d-block btn with-radius-sm extra-btn ">Cancel</button>
                                                            </div>
                                                            <div className="col-md-6 px-0">
                                                                <button className="w-100 d-block btn with-radius-sm  secondary-btn text-decoration-none ">Set Date</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Newsletter />
            <Footer />
        </>
    )
}
export default Timings;